AppBase.module('Components.PhoneMulticomplete', function (Module, App) {
  'use strict'

  var Tokens = App.Views.CollectionView.extend({
    className: 'tokens',
    tagName: 'ul',

    childView: Module.Token,
    childViewOptions: function (model) {
      return {
        model: model,
        theme: this.getOption('theme'),
      }
    },

    childEvents: {
      remove_token: 'removeToken',
    },

    collectionEvents: {
      add: 'toggleChildClass',
      remove: 'toggleChildClass',
    },

    behaviors: {
      SN_Theme: {},
    },

    onRender: function () {
      this.toggleChildClass()
    },

    /**
     * Remove a model/view from the collection.
     *
     * @param {Marionette.ItemView} view - View (with model) to remove from
     *   the collection.
     */
    removeToken: function (view) {
      var model = view.model

      this.collection.remove(model)
    },

    /**
     * Marks this view as `.is-empty` if there are no items in the
     * collection.
     */
    toggleChildClass: function () {
      this.$el.toggleClass('is-empty', !this.collection.length)
    },
  })
  Module.Tokens = Tokens
})
